import i18n from "i18n";

// Le etichette sono lette al momento dell'uso (getter), cosi' seguono la lingua corrente.
const optionalBoolean = [
  {
    value: true,
    get label() {
      return i18n.t("common:options.yes");
    },
  },
  {
    value: false,
    get label() {
      return i18n.t("common:options.no");
    },
  },
];
export const AttributesFields = [
  {
    name: "ean",
    type: "text",
  },
  { name: "name", type: "text", required: true },
  { name: "winery", type: "text", required: true },
  { name: "vintage", type: "text", required: true },
  {
    name: "denomination",
    type: "text",
  },
  {
    name: "gradation",
    type: "text",
    required: true,
    unit: "%",
  },
  {
    name: "vinification",
    type: "text",
  },
  { name: "terroir", type: "text" },
  { name: "region", type: "text" },
  {
    name: "format",
    type: "text",
    unit: "L",
  },
  {
    name: "country",
    type: "selectCountry",
  },
  {
    name: "natural",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  {
    name: "bio",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  {
    name: "have_sulphite",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  {
    name: "biodynamic",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  {
    name: "conventional",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  { name: "energy", type: "text" },
  {
    name: "fat",
    type: "text",

    unit: "g",
  },
  {
    name: "saturated_fat",
    type: "text",
    unit: "g",
  },
  {
    name: "carbohydrate",
    type: "text",
    unit: "g",
  },
  { name: "sugar", type: "text", unit: "g" },
  { name: "protein", type: "text", unit: "g" },
  { name: "salt", type: "text", unit: "g" },
  { name: "ingredients", type: "text" },
  { name: "fermentation", type: "text" },
  { name: "colour", type: "text" },
  { name: "appearance", type: "text" },
  { name: "aroma", type: "text" },
  { name: "taste", type: "text" },
  { name: "pairing", type: "text" },
  // {
  //   name: "is_approved",
  //   type: "select",

  //   staticOptions1: optionalBoolean,
  // },
  // {
  //   name: "is_active",
  //   type: "select",

  //   staticOptions1: optionalBoolean,
  // },
  {
    name: "description",
    type: "textarea",
    required: true,
  },
];

export const WineDataFields = [
  {
    name: "ean",
    type: "text",
  },
  { name: "name", type: "text", required: true },
  { name: "winery", type: "text" },
  { name: "vintage", type: "text" },
  {
    name: "denomination",
    type: "text",
  },
  {
    name: "gradation",
    type: "text",
    unit: "%",
  },
  {
    name: "vinification",
    type: "text",
  },
  { name: "terroir", type: "text" },
  { name: "region", type: "text" },
  {
    name: "format",
    type: "text",
    unit: "L",
  },
  {
    name: "country",
    type: "selectCountry",
  },
  {
    name: "natural",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  {
    name: "bio",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  {
    name: "have_sulphite",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  {
    name: "biodynamic",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  {
    name: "conventional",
    type: "select",
    staticOptions1: optionalBoolean,
  },
  { name: "energy", type: "text" },
  {
    name: "fat",
    type: "text",

    unit: "g",
  },
  {
    name: "saturated_fat",
    type: "text",
    unit: "g",
  },
  {
    name: "carbohydrate",
    type: "text",
    unit: "g",
  },
  { name: "sugar", type: "text", unit: "g" },
  { name: "protein", type: "text", unit: "g" },
  { name: "salt", type: "text", unit: "g" },
  { name: "ingredients", type: "text" },
  { name: "fermentation", type: "text" },
  { name: "colour", type: "text" },
  { name: "appearance", type: "text" },
  { name: "aroma", type: "text" },
  { name: "taste", type: "text" },
  { name: "pairing", type: "text" },
  {
    name: "is_approved",
    type: "select",

    staticOptions1: optionalBoolean,
  },
  {
    name: "is_active",
    type: "select",

    staticOptions1: optionalBoolean,
  },
  {
    name: "description",
    type: "textarea",
  },
];

export const AttributesImageFields = [
  { name: "front_bottle_image", type: "file" },
  { name: "back_bottle_image", type: "file" },
  { name: "front_label_image", type: "file" },
  { name: "back_label_image", type: "file" },
];

// Come WineDataFields, ma: la descrizione e' subito dopo i dati principali (ean, nome, cantina, annata)
// e i dati descrittivi (fermentazione, colore, gusto, abbinamenti) sono prima del blocco bio/naturale/ecc.
// Testi lunghi: occupano tutta la riga e sono campi di testo a piu' righe.
export const WIDE_TEXT_FIELDS = ["description", "appearance", "aroma", "taste", "pairing"];

export const WineDataFieldsOrdered = (() => {
  const moved = ["description", "fermentation", "colour", "appearance", "aroma", "taste", "pairing"];
  let fields = WineDataFields.filter((f) => !moved.includes(f.name));
  const pick = (names) => names.map((n) => WineDataFields.find((f) => f.name === n)).filter(Boolean);
  const insertAfter = (name, items) => {
    const at = fields.findIndex((f) => f.name === name) + 1;
    if (at > 0) fields = [...fields.slice(0, at), ...items, ...fields.slice(at)];
    else fields = [...fields, ...items];
  };
  insertAfter("vintage", pick(["description"]));
  const bioAt = fields.findIndex((f) => f.name === "bio");
  const descriptive = pick(["fermentation", "colour", "appearance", "aroma", "taste", "pairing"]);
  if (bioAt > 0) fields = [...fields.slice(0, bioAt), ...descriptive, ...fields.slice(bioAt)];
  else fields = [...fields, ...descriptive];
  return fields.map((f) =>
    WIDE_TEXT_FIELDS.includes(f.name) ? { ...f, type: "textarea" } : f
  );
})();
